__turbopack_context__.v({
  "categoryCard": "UnlockParadises-module__l5W3uG__categoryCard",
  "categoryGrid": "UnlockParadises-module__l5W3uG__categoryGrid",
  "categoryImage": "UnlockParadises-module__l5W3uG__categoryImage",
  "categoryLabel": "UnlockParadises-module__l5W3uG__categoryLabel",
  "categoryOverlay": "UnlockParadises-module__l5W3uG__categoryOverlay",
  "chip": "UnlockParadises-module__l5W3uG__chip",
  "chipHead": "UnlockParadises-module__l5W3uG__chipHead",
  "chipdesc": "UnlockParadises-module__l5W3uG__chipdesc",
  "countryArrow": "UnlockParadises-module__l5W3uG__countryArrow",
  "countryCard": "UnlockParadises-module__l5W3uG__countryCard",
  "countryCardActive": "UnlockParadises-module__l5W3uG__countryCardActive",
  "countryCardFlag": "UnlockParadises-module__l5W3uG__countryCardFlag",
  "countryCards": "UnlockParadises-module__l5W3uG__countryCards",
  "countryItem": "UnlockParadises-module__l5W3uG__countryItem",
  "countryItemActive": "UnlockParadises-module__l5W3uG__countryItemActive",
  "countryItemLeft": "UnlockParadises-module__l5W3uG__countryItemLeft",
  "countryList": "UnlockParadises-module__l5W3uG__countryList",
  "flag": "UnlockParadises-module__l5W3uG__flag",
  "heading": "UnlockParadises-module__l5W3uG__heading",
  "hero": "UnlockParadises-module__l5W3uG__hero",
  "heroBlock": "UnlockParadises-module__l5W3uG__heroBlock",
  "heroContent": "UnlockParadises-module__l5W3uG__heroContent",
  "heroDesc": "UnlockParadises-module__l5W3uG__heroDesc",
  "heroTitle": "UnlockParadises-module__l5W3uG__heroTitle",
  "infoCardCopy": "UnlockParadises-module__l5W3uG__infoCardCopy",
  "infoCarouselDots": "UnlockParadises-module__l5W3uG__infoCarouselDots",
  "infoFloat": "UnlockParadises-module__l5W3uG__infoFloat",
  "infoFloatCard": "UnlockParadises-module__l5W3uG__infoFloatCard",
  "infoIcon": "UnlockParadises-module__l5W3uG__infoIcon",
  "infoLabel": "UnlockParadises-module__l5W3uG__infoLabel",
  "infoSlide": "UnlockParadises-module__l5W3uG__infoSlide",
  "infoSliderWrap": "UnlockParadises-module__l5W3uG__infoSliderWrap",
  "infoValue": "UnlockParadises-module__l5W3uG__infoValue",
  "layout": "UnlockParadises-module__l5W3uG__layout",
  "main": "UnlockParadises-module__l5W3uG__main",
  "metaChips": "UnlockParadises-module__l5W3uG__metaChips",
  "regionSelect": "UnlockParadises-module__l5W3uG__regionSelect",
  "regionTab": "UnlockParadises-module__l5W3uG__regionTab",
  "regionTabActive": "UnlockParadises-module__l5W3uG__regionTabActive",
  "regionTabs": "UnlockParadises-module__l5W3uG__regionTabs",
  "section": "UnlockParadises-module__l5W3uG__section",
  "selectWrap": "UnlockParadises-module__l5W3uG__selectWrap",
  "sidebar": "UnlockParadises-module__l5W3uG__sidebar",
  "srOnly": "UnlockParadises-module__l5W3uG__srOnly",
  "toneGreen": "UnlockParadises-module__l5W3uG__toneGreen",
  "toneOrange": "UnlockParadises-module__l5W3uG__toneOrange",
  "tonePurple": "UnlockParadises-module__l5W3uG__tonePurple",
  "toneYellow": "UnlockParadises-module__l5W3uG__toneYellow",
});
